import moment from 'moment'
// import _ from 'lodash'

export default {
  data () {
    return {
      showPass: false,
      tags: [],
      media_type_ids: []
    }
  },
  methods: {
    showHidePass () {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
      this.showPass = !this.showPass
    },
    dateFormat (value) {
      return moment(value, 'YYYY-MM-DD').format('YYYY/MM/DD')
    },
    convertSize (value) {
      if (value <= 1024) {
        return value + 'Byte'
      } else if (value <= 1048576) {
        return (value / 1024).toFixed(2) + 'KB'
      } else {
        return (value / 1024 / 1024).toFixed(2) + 'MB'
      }
    },
    addParams () {
      this.tags = this.$route.query.tag ? this.$route.query.tag.split(',') : []
      this.media_type_ids = this.$route.query.type ? this.$route.query.type.split(',') : []
    },
    reloadFile (pageIndex, name, date) {
      if (this.$route.params.id === 'search') {
        this.addParams()
        const params = {page_index: pageIndex,
          tags: this.tags,
          start_date: this.$route.query.begin,
          end_date: this.$route.query.end,
          file_name: this.$route.query.file,
          folder_parent_id: this.$route.query.folder,
          media_type_ids: this.media_type_ids,
          author_id: this.$route.query.author,
          name: name,
          updated_at: date}
        this.$store.dispatch('managerFolder/searchFile', params)
      } else {
        this.$store.dispatch('managerFolder/getFolder', {page_index: pageIndex, folder_parent_id: this.$route.params.id, name: name, updated_at: date})
      }
    },
    reloadFileEmployee (pageIndex, name, date) {
      if (this.$route.params.id === 'search') {
        this.addParams()
        const params = {
          page_index: pageIndex,
          tags: this.tags,
          start_date: this.$route.query.begin,
          end_date: this.$route.query.end,
          file_name: this.$route.query.file,
          folder_parent_id: this.$route.query.folder,
          media_type_ids: this.media_type_ids,
          author_id: this.$route.query.author,
          name: name,
          updated_at: date}
        this.$store.dispatch('employeeFolder/searchFile', params)
      } else {
        this.$store.dispatch('employeeFolder/getFolder', {page_index: pageIndex, folder_parent_id: this.$route.params.id, name: name, updated_at: date})
      }
    },
    reloadFileAdmin (pageIndex, name, date) {
      if (this.$route.params.folder_id === 'search') {
        this.addParams()
        const params = {page_index: pageIndex,
          tags: this.tags,
          start_date: this.$route.query.begin,
          end_date: this.$route.query.end,
          file_name: this.$route.query.file,
          folder_parent_id: this.$route.query.folder,
          media_type_ids: this.media_type_ids,
          author_id: this.$route.query.author,
          company_id: this.$route.params.id,
          name: name,
          updated_at: date}
        this.$store.dispatch('adminFolder/searchFile', params)
      } else {
        this.$store.dispatch('adminFolder/getFolder', {page_index: pageIndex, folder_parent_id: this.$route.params.folder_id, company_id: this.$route.params.id, name: name, updated_at: date})
      }
    },
    isArray (query) {
      return query === 'type' || query === 'tag'
    },
    truncate (text, length, suffix) {
      if (text && text.length > length) {
        return text.substring(0, length) + suffix
      } else {
        return text
      }
    },
    formatNumber (value) {
      if (!value) return 0
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    formatNumberDashBoard (value) {
      if (!value) return 0
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    notify (variant, option) {
      this.$bvToast.toast(option.message, {
        title: option.title,
        variant: variant || 'default',
        solid: false,
        appendToast: option.append || true,
        autoHideDelay: 2500,
        toastClass: `theme-toast ${variant}`
      })
    },
    secondsToHHMMSS (duration) {
      var secNum = parseInt(duration, 10)
      var hours = Math.floor(secNum / 3600)
      var minutes = Math.floor((secNum - (hours * 3600)) / 60)
      var seconds = secNum - (hours * 3600) - (minutes * 60)

      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }

      return {
        readableFormat: hours + ':' + minutes + ':' + seconds,
        hours: hours,
        minutes: minutes,
        seconds: seconds
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixin.js